export default __webpack_public_path__ + "static/media/mail.de4bb139.svg";